const RESERVED_ROOT_SEGMENTS = new Set([
  'admin',
  'invitations',
  'access-denied',
  'reset-password',
  'settings',
  'my-campaigns',
  'my-team',
]);

/** Station marketing landing (`/:slug` with Get started) — not the wizard. */
export function isStationLandingPage(pathname: string): boolean {
  const match = pathname.match(/^\/([^/]+)$/);
  if (!match) return false;
  return !RESERVED_ROOT_SEGMENTS.has(match[1]);
}

export function shouldShowHelpMenu(pathname: string): boolean {
  if (pathname.startsWith('/admin')) return false;
  if (isStationLandingPage(pathname)) return false;
  return true;
}
